import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';

export class ProcessScenario extends BasicScenario {
manageMappings: boolean | null;
manageSteps: boolean | null;
}

